"use client";

import { useState } from "react";
import { PreOrderList } from "./components/PreOrderList";
import { PreOrderSearch } from "./components/PreOrderSearch";

export default function PreOrder() {
  const [searchTerm, setSearchTerm] = useState("");
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [statusFilter, setStatusFilter] = useState("PENDING");

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    // Reset status filter to "all" when searching
    if (term) {
      setStatusFilter("all");
    }
  };

  const handleStatusChange = (status: string) => {
    setStatusFilter(status);
    // Clear search term when changing status
    setSearchTerm("");
  };

  return (
    <main className="container mx-auto py-6 px-4 max-w-6xl">
      <h1 className="text-xl font-medium mb-6 text-gray-800">
        Sistema de Gerenciamento de Pré-Pedidos
      </h1>
      <PreOrderSearch onSearch={handleSearch} searchTerm={searchTerm} />
      <PreOrderList
        searchTerm={searchTerm}
        refreshTrigger={refreshTrigger}
        onRefresh={handleRefresh}
        statusFilter={statusFilter}
        onStatusChange={handleStatusChange}
      />
    </main>
  );
}
